// extracted by mini-css-extract-plugin
module.exports = {"modalCard":"WithdrawalModalStepTwo_modalCard__2qofR","radioButton":"WithdrawalModalStepTwo_radioButton__32ujZ","active":"WithdrawalModalStepTwo_active__2sYYN"};